module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (32).8bfb7e2a.jpg";